import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import PageBookmarkBtn from 'components/PageBookmarkBtn/PageBookmarkBtn';
import EditBtn from './components/EditBtn';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../restaurantFullInfoState/restaurantFullInfoContext';
import style from './RestaurantFullInfoControlPanel.module.scss';

const RestaurantFullInfoControlPanel: React.FC = () => {
	const { changeRestaurantFullInfoVisibleForm, restaurantForFullInfo, restaurantFullInfoVisibleForm } =
		useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const hasDevicesFormAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);
	const hasAdditionallyFormAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);
	const hasWatchesFormAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);
	const hasBankSettingsFormAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);
	// const hasReportsFormAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);
	const hasAndroidWatchesFormAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);

	return (
		<div className={style.container} data-test="RestaurantFullInfoControlPanel">
			<div className={style.heading}>
				<Text
					className={style.headingText}
					translationKey={restaurantForFullInfo?.name || null}
					size="xl"
					weight="bold"
				/>
				<EditBtn />
			</div>
			<div className={style.bookMarks}>
				<PageBookmarkBtn
					onClick={() => changeRestaurantFullInfoVisibleForm('mainForm')}
					isActive={restaurantFullInfoVisibleForm === 'mainForm'}
					btnName="mainInfoBookmark"
				/>
				<PageBookmarkBtn
					onClick={() => changeRestaurantFullInfoVisibleForm('localizationForm')}
					isActive={restaurantFullInfoVisibleForm === 'localizationForm'}
					btnName="localizationBookmark"
				/>
				<PageBookmarkBtn
					onClick={() => changeRestaurantFullInfoVisibleForm('styleForm')}
					isActive={restaurantFullInfoVisibleForm === 'styleForm'}
					btnName="styleBookmark"
				/>
				<PageBookmarkBtn
					onClick={() => changeRestaurantFullInfoVisibleForm('softwareForm')}
					isActive={restaurantFullInfoVisibleForm === 'softwareForm'}
					btnName="softwareBookmark"
				/>
				<PageBookmarkBtn
					onClick={() => changeRestaurantFullInfoVisibleForm('devicesForm')}
					isActive={restaurantFullInfoVisibleForm === 'devicesForm'}
					btnName="devicesBookmark"
					disabled={!hasDevicesFormAccess}
				/>
				<PageBookmarkBtn
					onClick={() => changeRestaurantFullInfoVisibleForm('additionallyForm')}
					isActive={restaurantFullInfoVisibleForm === 'additionallyForm'}
					btnName="additionallyBookmark"
					disabled={!hasAdditionallyFormAccess}
				/>
				<PageBookmarkBtn
					onClick={() => changeRestaurantFullInfoVisibleForm('watchesForm')}
					isActive={restaurantFullInfoVisibleForm === 'watchesForm'}
					btnName="watchesBookmark"
					disabled={!hasWatchesFormAccess}
				/>
				<PageBookmarkBtn
					onClick={() => changeRestaurantFullInfoVisibleForm('bankSettingsForm')}
					isActive={restaurantFullInfoVisibleForm === 'bankSettingsForm'}
					btnName="bankSettingsBookmark"
					disabled={!hasBankSettingsFormAccess}
				/>
				{/* TODO need to be remade for a new flow */}
				{/* <PageBookmarkBtn
					onClick={() => changeRestaurantFullInfoVisibleForm('reportsForm')}
					isActive={restaurantFullInfoVisibleForm === 'reportsForm'}
					btnName="reportSettingsBookmark"
					disabled={!hasReportsFormAccess}
				/> */}
				{/* TODO need to be remade for a new flow */}
				<PageBookmarkBtn
					onClick={() => changeRestaurantFullInfoVisibleForm('androidWatchesForm')}
					isActive={restaurantFullInfoVisibleForm === 'androidWatchesForm'}
					btnName="androidWatchesBookmark"
					disabled={!hasAndroidWatchesFormAccess}
				/>
			</div>
		</div>
	);
};

export default RestaurantFullInfoControlPanel;
